import sortable from "html5sortable/dist/html5sortable.es";

/* expects each sortable item(each element in the container with the sortable class), to have a data.path pointing to the action to take when an item has been moved. */

document.addEventListener("DOMContentLoaded", function () {
  const sortableElements = sortable("[data-sortable=true]", {
    placeholderClass: "options-list-sortable-placeholder",
    acceptFrom: "[data-sortable=true]",
    items: ".sort-item",
  });

  let sortingData = [];

  for (let sortableElement of sortableElements) {
    sortableElement.addEventListener("sortstart" , (e: HTMLElement) => {
      document.querySelectorAll("[data-sortable]").forEach(container => {
        container.classList.add("sorting");
        container.querySelectorAll(".collapse").forEach(element => {
          element.classList.add("show");
        });
        container.querySelectorAll("[aria-expanded]").forEach(element => {
          element.setAttribute("aria-expanded","true");
        });
      });
    });

    sortableElement.addEventListener("sortstop" , (e: HTMLElement) => {
      document.querySelectorAll("[data-sortable]").forEach(container => {
        container.classList.remove("sorting");
      });
    });

    sortableElement.addEventListener("sortupdate", async (e: HTMLFormElement) => {
      const form: HTMLFormElement = setupSortableSubmitForm();
      const immediateSubmitPath = e.detail.item.dataset.path;
      const sortableId = e.detail.item.dataset.sortableId;
      const position = e.detail.destination.index + 1;
      const parentId = e.detail.destination.container.dataset.parentId;

      if (immediateSubmitPath) {
        // Item has a path parameter, meaning immediate position can be submitted
        form.setAttribute("action", immediateSubmitPath);
        setParameter("position", position, form);
        setParameter("_method", "put", form);
        if (parentId) setParameter("parent_id", parentId, form);

        (form as HTMLFormElement).submit();
      } else {
        // Changes to item order is submitted in a batch when the form is explicitly submitted.
        sortingData = updateSortingData(sortingData, sortableId, position, parentId);
        setParameter("sorting-data", JSON.stringify(sortingData), form);

        const submitButton: HTMLButtonElement = document.querySelector("#sortableFormSubmit");
        form.setAttribute("action", submitButton.dataset.path);
        setParameter("_method", "post", form);

        if (submitButton) submitButton.classList.remove("d-none");

        setupUnsavedChangesListener(submitButton);
      }
    });
  }

});

function setupSortableSubmitForm(): HTMLFormElement {
  const existingForm = document.getElementById("sortableForm") as HTMLFormElement;
  if (existingForm) return existingForm;

  const form: HTMLFormElement = document.createElement("form");
  const csrfParam = document.querySelector("meta[name=csrf-param]").getAttribute("content");
  const csrfToken = document.querySelector("meta[name=csrf-token]").getAttribute("content");
  form.setAttribute("id", "sortableForm");
  form.setAttribute("method", "post");
  setParameter("sorting-data", "[]", form);
  setParameter(csrfParam, csrfToken, form);
  form.style.display = "none";
  document.body.appendChild(form);

  return form;
}

function setParameter(name: string, value: string, form: HTMLFormElement) {
  let parameter: HTMLInputElement = form.querySelector(`input[name="${name}"]`);
  if (!parameter) {
    parameter = document.createElement("input");
    parameter.setAttribute("name", name);
    parameter.setAttribute("value", `${value}`);
    form.appendChild(parameter);
  } else {
    parameter.setAttribute("value", `${value}`);
  }
}

function updateSortingData(sortingData: any[], sortableId: number, position: number, parentId: number) {
  const existing = sortingData.find(x => x.id === sortableId);

  if (existing) {
    const sliceIndex = sortingData.indexOf(existing);
    sortingData.splice(sliceIndex, 1);
    existing.position = position;
    existing.parentId = parentId;

    sortingData.push(existing);
  } else {
    sortingData.push({ id: sortableId, position: position, parentId: parentId });
  }

  return sortingData;
}

function setupUnsavedChangesListener(submitButton: HTMLButtonElement) {
  let areYouSureFunc = function () {
    return ""; // Webkit, Safari, Chrome etc.
  }

  window.addEventListener("beforeunload", areYouSureFunc);

  submitButton.addEventListener("click", () => {
    window.removeEventListener("beforeunload", areYouSureFunc);
  });
}
